function e(e) {
  return function (n) {
    for (var t in n) {
      e(t) || delete n[t];
    }
  };
}
export { e as shouldForwardProp };